class MarmetoProductCard extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    if (this.querySelector("script")) {
      this.variantData = JSON.parse(this.querySelector("script").textContent);
    }
    this.productCardVariants = this.querySelectorAll(".swatch-element");
    this.applyInitialSelectedBorder();
    this.productCardVariants.forEach((eachVariant) => {
      eachVariant.addEventListener("click", (event) => {
        event.stopPropagation(); // Stop the event from propagating further
        this.handleSwatchClick(eachVariant);
        this.updatePrice(eachVariant);
        this.variantChange(event);
        this.updateVariantId(eachVariant)
      });
    });
    const firstAvailableVariant = this.querySelector(".swatch-element.available");
    if (firstAvailableVariant) {
      this.updateHoverImage(firstAvailableVariant);
    }
  }
  applyInitialSelectedBorder() {
    const firstAvailableVariant = this.querySelector(".swatch-element.available");
    if (firstAvailableVariant) {
      firstAvailableVariant.classList.add("selected");
      this.updateHoverImage(firstAvailableVariant); 
    }
  }
  handleSwatchClick(clickedVariant) {
    this.productCardVariants.forEach((variant) => {
      variant.classList.remove("selected");
    });
    clickedVariant.classList.add("selected");
    this.updateProductCardImg(clickedVariant, this.variantData);
    this.updateHoverImage(clickedVariant); // Update hover image on variant click
  }
  updateProductCardImg(eachVariant, variantData) {
    this.inputEle = eachVariant.querySelector("input");
    this.selectedVariantId = this.inputEle.dataset.variant;
    this.productCardHandle = this.inputEle.dataset.handle;
    const imgElement = this.querySelector('.first--image');
    const altName = eachVariant.dataset.value;
    const matchedVariant = variantData.variants.find(variant => variant.id == this.selectedVariantId);
    let imageSrc = null;
    if (matchedVariant) {
      if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
        imageSrc = matchedVariant.featured_image.src;
      } else {
        const media = variantData.media.find(mediaItem => mediaItem.alt === altName);
        if (media && media.preview_image && media.preview_image.src) {
          imageSrc = media.preview_image.src;
        }
      }
      if (imageSrc) {
        imgElement.setAttribute('srcset', imageSrc);
      }
    }
    this.updateUrl(this.productCardHandle, this.selectedVariantId);
  }
  updateHoverImage(eachVariant) {
    this.hoverImageLink = eachVariant.dataset.hoverImageSrc;
    const hoverImgElement = this.querySelector('.hover-image');
    if (this.hoverImageLink && hoverImgElement) {
      hoverImgElement.setAttribute('srcset', this.hoverImageLink);
    }
  }
  updateUrl(productCardHandle, selectedVariantId) {
    this.productUrl = `/products/${productCardHandle}?variant=${selectedVariantId}`;
    this.anchorEle = this.querySelectorAll('.product__card__link');
    if (this.anchorEle) {
      this.anchorEle.forEach((eachLink) => eachLink.setAttribute('href', this.productUrl))
    }
  }
  updatePrice(eachVariant) {
    const priceElement = this.querySelector('.product-price');
    const compareAtPriceElement = this.querySelector('.product-compare-at-price');
    const variantPrice = eachVariant.dataset.variantPrice;
    const variantCompareAtPrice = eachVariant.dataset.variantComapreAtPrice;
    if (variantPrice && priceElement) {
      priceElement.innerHTML = `${variantPrice}`;
    }
    if (compareAtPriceElement && variantCompareAtPrice) {
      compareAtPriceElement.innerHTML = `${variantCompareAtPrice}`;
    }
  }
  updateVariantId(eachVariant){
    const variantId = eachVariant.dataset.variantId
    const varaintInputEle = this.querySelector('.product-variant-id')
    if (variantId && varaintInputEle){
      varaintInputEle.setAttribute('value', `${variantId}`)
    }
  }
  variantChange(event) {
    const clickedVariant = event.target.closest('.swatch-element');
    if (clickedVariant) {
      this.handleSwatchClick(clickedVariant);
    }
  }
}

customElements.define("marmeto-product-card", MarmetoProductCard);
